import LazyChartControllerBase from './helpers/lazy_chart_controller_base';
import { ChartFormattingMixin } from './concerns/chart_formatting_mixin';
import Chart from 'chart.js/auto';

export default class extends LazyChartControllerBase {
  static values = { inputs: String, title: String, dataFormat: String };
  static targets = ['chartcanvas'];

  _buildChart() {
    const chartData = JSON.parse(this.inputsValue);
    Object.assign(this, ChartFormattingMixin);

    const plugins = {
      legend: {
        display: false,
      },
      tooltip: {
        label: 'Productivity Ratio',
        callbacks: {
          label: this.tooltipFormat(),
        },
      },
    };

    if (this.titleValue?.trim()) {
      plugins.title = {
        display: true,
        text: this.titleValue,
        position: 'top',
        align: 'center',
        color: '#ffffff',
      };
    }

    const chartOptions = {
      plugins,
      elements: {
        bar: {
          backgroundColor: 'rgba(255, 255, 255, 0.85)',
          borderRadius: 5,
        },
      },
      scales: {
        y: {
          type: 'linear',
          grace: this.setGrace(chartData.datasets),
          beginAtZero: false,

          grid: {
            display: true,
            drawOnChartArea: true,
            drawTicks: true,
          },
          ticks: {
            color: '#ffffff',
            callback: this.ticksFormat(),
          },
        },
        x: {
          border: {
            display: false,
          },
          ticks: {
            maxTicksLimit: 16,
            color: '#ffffff',
          },
        },
      },
    };

    new Chart(this.chartcanvasTarget, {
      type: 'bar',
      data: chartData,
      options: chartOptions,
    });
  }
}
